angular.module( 'acme.view.application.permissions.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.permissions.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var permissionsList = {
        name: 'application.permissions.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'PermissionsListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/permissions/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Manage Permissions',
          permissions: ['PERMISSIONS_VIEW']
        }
      };

    $stateProvider
      .state(permissionsList);
});
